module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAC9JREFUeNpiZMAN/qPxGbEpYmKgEIwaAAnZ/6NhwGCPQ+4AGt8BlwGjSZlCABBgAKWaBFs08xI0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/plus.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/plus.png
// module chunks = styles